module.exports = __webpack_public_path__ + "img/no_data_cn.8790a5bc.png";